export default {
    methods: {
        showText: function(zh, en) {
            if(this.$i18n.locale == 'zh') {
                return zh;
            }
            if(this.$i18n.locale == 'en') {
                return en;
            }
        }
    }
}
